var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextBlock"},[_vm._t("default",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatted)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }